import React from "react";

import type { IGoal } from "../types";
import { GoalItem } from "./GoalItem";

interface GoalsProps {
  goals: IGoal[];
}

export const Goals: React.FC<GoalsProps> = ({ goals }) => {
  return (
    <div className="my-8 flex flex-col gap-6 w-full">
      {goals.map((goal) => (
        <GoalItem key={goal.id} goal={goal} />
      ))}
    </div>
  );
};
